export default {
	AbbreviationSetups: []
};
